import { render, staticRenderFns } from "./div-width.vue?vue&type=template&id=5137dd4f&scoped=true"
import script from "./div-width.vue?vue&type=script&lang=js"
export * from "./div-width.vue?vue&type=script&lang=js"
import style0 from "./div-width.vue?vue&type=style&index=0&id=5137dd4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137dd4f",
  null
  
)

export default component.exports